import router from './router';
import store from './store';
import { Message } from 'element-ui';
import NProgress from 'nprogress' // progress bar
import 'nprogress/nprogress.css' // progress bar style
import { getToken } from '@/utils/auth' // get token from cookie

NProgress.configure({ showSpinner: false }) // NProgress Configuration

const whiteList = ['/login', '/auth-redirect'] // no redirect whitelist
//全局路由导航前置守卫
router.beforeEach(async(to, from, next) => {
  NProgress.start()
  const hasToken = getToken();
  if (hasToken) {
    if (to.path === '/login') {
      next({ path: '/' })
      NProgress.done()
    } else {
      const isLogin = store.getters.isLogin;
      if (isLogin) {
        next();
      } else {
        try {
              const authlist = await store.dispatch('user/getInfo');//这里获取到的用户登录信息，返回权限列表
              store.dispatch('permission/generateRoutes', authlist).then((res) => {
                  router.addRoutes(res)
                  next({ ...to, replace: true })
              })
        } catch (error) {
          await store.dispatch('user/resetToken')
          Message.error(error || '错误')
          next("/login")
          NProgress.done()
        }
      }
    }
  } else {
    if (whiteList.indexOf(to.path) !== -1) {
      next()
    } else {
      next("/login")
      NProgress.done()
    }
  }
})

router.afterEach(() => {
  NProgress.done()
})



// WEBPACK FOOTER //
// ./src/permission.js